import { supabase } from "../../config/supabase";

// Get Challenges
const getChallengeById = async (challengeId) => {
    try {
        const { data, error } = await supabase.from('challenges').select('*').eq('challenge_id', challengeId).single();
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting challenges:',err);
        return { error: err, data:null };
    }
};

const getAllChallenges = async (page,limit = 10) => {
    try {
        const { data, error } = await supabase.from('challenges').select('*', { count: 'exact' }).range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting challenges:',err);
        return { error: err, data: null };
    }
};

const getAllChallengesIds = async () => {
    try {
        const { data, error } = await supabase.from('challenges').select('challenge_id,title') //.range((page - 1) * limit, page * limit - 1); // Calculate range for pagination
        if (error) throw new Error(error);
        return { error: null, data };
    } catch (err) {
        console.log('an error in getting challenges:',err);
        return { error: err, data: null };
    }
};

export { getChallengeById, getAllChallenges, getAllChallengesIds };